var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBookmark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.24998 3.00003C6.91846 3.00003 6.60052 3.13173 6.3661 3.36615C6.13168 3.60057 5.99998 3.91851 5.99998 4.25003V19.5111L11.5536 15.3973C11.8188 15.2009 12.1812 15.2009 12.4464 15.3973L18 19.5111V4.25003C18 3.91851 17.8683 3.60057 17.6339 3.36615C17.3994 3.13173 17.0815 3.00003 16.75 3.00003H7.24998ZM5.30544 2.30549C5.82117 1.78976 6.52064 1.50003 7.24998 1.50003H16.75C17.4793 1.50003 18.1788 1.78976 18.6945 2.30549C19.2103 2.82121 19.5 3.52068 19.5 4.25003V21C19.5 21.2833 19.3404 21.5424 19.0874 21.6698C18.8344 21.7973 18.5312 21.7713 18.3036 21.6027L12 16.9333L5.6964 21.6027C5.46878 21.7713 5.16557 21.7973 4.91258 21.6698C4.65959 21.5424 4.49998 21.2833 4.49998 21V4.25003C4.49998 3.52069 4.78972 2.82121 5.30544 2.30549Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBookmark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bookmark.a0bb8871b03a4b11189a0d90a1b255bd.svg";